module.exports = __webpack_public_path__ + "img/floor2_top3.6b869be6.png";